/**
 * Карповые — 70 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const КАРПОВЫЕ = [
    // ── Наши воды ──
    {
        id: 'bream',
        семейство: 'карповые',
        latin: 'Abramis brama',
        повадка: 'крупная_бель',
        minKg: 0.1,
        maxKg: 6,
        typicalKg: 0.8,
        typicalLengthM: 0.4,
        depthM: 3.5,
        depthBandM: 2,
        сложение: 'ленточное',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 6, опт: 20, макс: 28 },
        течение: 'слабое',
        держится: ['ил', 'бровка', 'яма'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'перловка', вес: 0.6 },
            { чем: 'кукуруза', вес: 0.6 },
            { чем: 'горох', вес: 0.4 },
            { чем: 'пеллетс', вес: 0.4 },
        ],
    },
    {
        id: 'silver_bream',
        семейство: 'карповые',
        latin: 'Blicca bjoerkna',
        повадка: 'стайная_бель',
        minKg: 0.05,
        maxKg: 1.2,
        typicalKg: 0.2,
        typicalLengthM: 0.22,
        depthM: 2.5,
        depthBandM: 1.8,
        сложение: 'ленточное',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'сумеречная',
        вода: { мин: 8, опт: 20, макс: 28 },
        течение: 'слабое',
        держится: ['ил', 'бровка', 'трава'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'опарыш', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'перловка', вес: 0.6 },
            { чем: 'тесто', вес: 0.4 },
            { чем: 'хлеб', вес: 0.2 },
        ],
    },
    {
        id: 'blue_bream',
        семейство: 'карповые',
        latin: 'Ballerus ballerus',
        повадка: 'стайная_бель',
        minKg: 0.1,
        maxKg: 1.6,
        typicalKg: 0.35,
        typicalLengthM: 0.28,
        depthM: 4,
        depthBandM: 2,
        сложение: 'ленточное',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 8, опт: 18, макс: 26 },
        течение: 'слабое',
        держится: ['открытая_вода', 'бровка', 'яма'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'рачок', вес: 0.4 },
            { чем: 'перловка', вес: 0.2 },
        ],
    },
    {
        id: 'white_bream',
        семейство: 'карповые',
        latin: 'Ballerus sapa',
        повадка: 'стайная_бель',
        minKg: 0.1,
        maxKg: 1,
        typicalKg: 0.3,
        typicalLengthM: 0.25,
        depthM: 4.5,
        depthBandM: 2,
        сложение: 'ленточное',
        пасть: 'плёночная',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 8, опт: 18, макс: 26 },
        течение: 'сильное',
        держится: ['бровка', 'твёрдое_дно', 'яма'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'ракушка', вес: 0.4 },
            { чем: 'перловка', вес: 0.4 },
        ],
    },
    {
        id: 'carp',
        семейство: 'карповые',
        latin: 'Cyprinus carpio',
        повадка: 'карповый_силач',
        minKg: 0.5,
        maxKg: 25,
        typicalKg: 3,
        typicalLengthM: 0.55,
        depthM: 2.5,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 12, опт: 24, макс: 30 },
        течение: 'слабое',
        держится: ['коряги', 'трава', 'ил'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'бойл', вес: 1 },
            { чем: 'кукуруза', вес: 0.8 },
            { чем: 'пеллетс', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'горох', вес: 0.6 },
            { чем: 'тесто', вес: 0.4 },
            { чем: 'хлеб', вес: 0.4 },
        ],
    },
    {
        id: 'wild_carp',
        семейство: 'карповые',
        latin: 'Cyprinus carpio carpio',
        повадка: 'карповый_силач',
        minKg: 1,
        maxKg: 20,
        typicalKg: 4,
        typicalLengthM: 0.6,
        depthM: 3,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 12, опт: 24, макс: 30 },
        течение: 'слабое',
        держится: ['коряги', 'яма', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'кукуруза', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'горох', вес: 0.8 },
            { чем: 'бойл', вес: 0.6 },
            { чем: 'пеллетс', вес: 0.6 },
            { чем: 'ракушка', вес: 0.4 },
            { чем: 'перловка', вес: 0.4 },
        ],
    },
    {
        id: 'crucian',
        семейство: 'карповые',
        latin: 'Carassius carassius',
        повадка: 'стайная_бель',
        minKg: 0.05,
        maxKg: 2.5,
        typicalKg: 0.25,
        typicalLengthM: 0.2,
        depthM: 1.5,
        depthBandM: 1.2,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 10, опт: 22, макс: 32 },
        течение: 'стоячая',
        держится: ['трава', 'ил', 'коряги'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'тесто', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'мотыль', вес: 0.6 },
            { чем: 'перловка', вес: 0.6 },
            { чем: 'хлеб', вес: 0.4 },
            { чем: 'кукуруза', вес: 0.4 },
        ],
    },
    {
        id: 'gibel_carp',
        семейство: 'карповые',
        latin: 'Carassius gibelio',
        повадка: 'стайная_бель',
        minKg: 0.05,
        maxKg: 3,
        typicalKg: 0.3,
        typicalLengthM: 0.22,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'сумеречная',
        вода: { мин: 10, опт: 22, макс: 32 },
        течение: 'слабое',
        держится: ['ил', 'трава', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'опарыш', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'тесто', вес: 0.8 },
            { чем: 'мотыль', вес: 0.6 },
            { чем: 'кукуруза', вес: 0.6 },
            { чем: 'перловка', вес: 0.4 },
            { чем: 'пеллетс', вес: 0.4 },
        ],
    },
    {
        id: 'roach',
        семейство: 'карповые',
        latin: 'Rutilus rutilus',
        повадка: 'стайная_бель',
        minKg: 0.02,
        maxKg: 1.4,
        typicalKg: 0.12,
        typicalLengthM: 0.18,
        depthM: 2,
        depthBandM: 1.8,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 6, опт: 18, макс: 26 },
        течение: 'слабое',
        держится: ['трава', 'коряги', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'опарыш', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'перловка', вес: 0.6 },
            { чем: 'тесто', вес: 0.6 },
            { чем: 'ручейник', вес: 0.4 },
            { чем: 'зелень', вес: 0.4 },
        ],
    },
    {
        id: 'kutum',
        семейство: 'карповые',
        latin: 'Rutilus frisii',
        повадка: 'крупная_бель',
        minKg: 0.5,
        maxKg: 8,
        typicalKg: 1.5,
        typicalLengthM: 0.45,
        depthM: 3,
        depthBandM: 2,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 8, опт: 18, макс: 26 },
        течение: 'слабое',
        держится: ['твёрдое_дно', 'бровка', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'ракушка', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'рачок', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'кукуруза', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    {
        id: 'rudd',
        семейство: 'карповые',
        latin: 'Scardinius erythrophthalmus',
        повадка: 'стайная_бель',
        minKg: 0.03,
        maxKg: 2,
        typicalKg: 0.2,
        typicalLengthM: 0.2,
        depthM: 1.2,
        depthBandM: 1.2,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 12, опт: 22, макс: 30 },
        течение: 'стоячая',
        держится: ['трава', 'поверхность', 'коряги'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'тесто', вес: 1 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'кузнечик', вес: 0.6 },
            { чем: 'хлеб', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'зелень', вес: 0.4 },
        ],
    },
    {
        id: 'ide',
        семейство: 'карповые',
        latin: 'Leuciscus idus',
        повадка: 'угонщик',
        minKg: 0.2,
        maxKg: 6,
        typicalKg: 0.8,
        typicalLengthM: 0.4,
        depthM: 1.8,
        depthBandM: 1.5,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 8, опт: 18, макс: 26 },
        течение: 'слабое',
        держится: ['коряги', 'бровка', 'трава'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'кузнечик', вес: 0.6 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'горох', вес: 0.4 },
            { чем: 'мушка', вес: 0.4 },
        ],
    },
    {
        id: 'chub',
        семейство: 'карповые',
        latin: 'Squalius cephalus',
        повадка: 'угонщик',
        minKg: 0.15,
        maxKg: 5,
        typicalKg: 0.7,
        typicalLengthM: 0.38,
        depthM: 1,
        depthBandM: 1.2,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 10, опт: 20, макс: 28 },
        течение: 'сильное',
        держится: ['перекат', 'камни', 'коряги'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'кузнечик', вес: 0.8 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'фрукт', вес: 0.6 },
            { чем: 'хлеб', вес: 0.4 },
            { чем: 'лягушка', вес: 0.2 },
        ],
    },
    {
        id: 'dace',
        семейство: 'карповые',
        latin: 'Leuciscus leuciscus',
        повадка: 'стайная_бель',
        minKg: 0.03,
        maxKg: 0.6,
        typicalKg: 0.12,
        typicalLengthM: 0.18,
        depthM: 1,
        depthBandM: 1,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 4, опт: 16, макс: 24 },
        течение: 'сильное',
        держится: ['перекат', 'твёрдое_дно', 'камни'],
        стая: 'большая_стая',
        нерест: { с: 3, по: 4 },
        чем: [
            { чем: 'опарыш', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'ручейник', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'тесто', вес: 0.2 },
        ],
    },
    {
        id: 'tench',
        семейство: 'карповые',
        latin: 'Tinca tinca',
        повадка: 'карповый_силач',
        minKg: 0.2,
        maxKg: 7,
        typicalKg: 1,
        typicalLengthM: 0.4,
        depthM: 1.5,
        depthBandM: 1.2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 14, опт: 24, макс: 30 },
        течение: 'стоячая',
        держится: ['трава', 'ил', 'коряги'],
        стая: 'одиночка',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'перловка', вес: 0.6 },
            { чем: 'кукуруза', вес: 0.6 },
            { чем: 'тесто', вес: 0.4 },
            { чем: 'горох', вес: 0.4 },
            { чем: 'мотыль', вес: 0.2 },
        ],
    },
    {
        id: 'nase',
        семейство: 'карповые',
        latin: 'Chondrostoma nasus',
        повадка: 'стайная_бель',
        minKg: 0.1,
        maxKg: 2,
        typicalKg: 0.4,
        typicalLengthM: 0.3,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'прогонистое',
        пасть: 'хрящевая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 6, опт: 16, макс: 24 },
        течение: 'сильное',
        держится: ['перекат', 'камни', 'твёрдое_дно'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'зелень', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'ручейник', вес: 0.4 },
            { чем: 'тесто', вес: 0.4 },
        ],
    },
    {
        id: 'barbel',
        семейство: 'карповые',
        latin: 'Barbus barbus',
        повадка: 'карповый_силач',
        minKg: 0.3,
        maxKg: 10,
        typicalKg: 1.5,
        typicalLengthM: 0.5,
        depthM: 3,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 12, опт: 20, макс: 28 },
        течение: 'сильное',
        держится: ['камни', 'перекат', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'пеллетс', вес: 0.8 },
            { чем: 'кукуруза', вес: 0.8 },
            { чем: 'бойл', вес: 0.6 },
            { чем: 'ракушка', вес: 0.6 },
            { чем: 'мясо', вес: 0.4 },
        ],
    },
    {
        id: 'dnieper_barbel',
        семейство: 'карповые',
        latin: 'Barbus borysthenicus',
        повадка: 'карповый_силач',
        minKg: 0.3,
        maxKg: 6,
        typicalKg: 1.2,
        typicalLengthM: 0.45,
        depthM: 3,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 12, опт: 21, макс: 29 },
        течение: 'сильное',
        держится: ['камни', 'твёрдое_дно', 'перекат'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'кукуруза', вес: 0.8 },
            { чем: 'ракушка', вес: 0.6 },
            { чем: 'пеллетс', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'мясо', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'grass_carp',
        семейство: 'карповые',
        latin: 'Ctenopharyngodon idella',
        повадка: 'карповый_силач',
        minKg: 1,
        maxKg: 30,
        typicalKg: 5,
        typicalLengthM: 0.7,
        depthM: 1.5,
        depthBandM: 1.5,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'дневная',
        вода: { мин: 16, опт: 26, макс: 33 },
        течение: 'слабое',
        держится: ['трава', 'поверхность', 'открытая_вода'],
        стая: 'малая_стая',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'зелень', вес: 1 },
            { чем: 'горох', вес: 1 },
            { чем: 'кукуруза', вес: 0.8 },
            { чем: 'тесто', вес: 0.6 },
            { чем: 'пеллетс', вес: 0.6 },
            { чем: 'фрукт', вес: 0.4 },
        ],
    },
    {
        id: 'black_carp',
        семейство: 'карповые',
        latin: 'Mylopharyngodon piceus',
        повадка: 'карповый_силач',
        minKg: 2,
        maxKg: 35,
        typicalKg: 7,
        typicalLengthM: 0.8,
        depthM: 4,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 16, опт: 26, макс: 32 },
        течение: 'слабое',
        держится: ['твёрдое_дно', 'яма', 'бровка'],
        стая: 'одиночка',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'ракушка', вес: 1 },
            { чем: 'бойл', вес: 0.6 },
            { чем: 'пеллетс', вес: 0.6 },
            { чем: 'кукуруза', вес: 0.4 },
            { чем: 'червь', вес: 0.4 },
            { чем: 'рачок', вес: 0.2 },
        ],
    },
    {
        id: 'silver_carp',
        семейство: 'карповые',
        latin: 'Hypophthalmichthys molitrix',
        повадка: 'карповый_силач',
        minKg: 1,
        maxKg: 25,
        typicalKg: 4,
        typicalLengthM: 0.65,
        depthM: 2,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'хрящевая',
        редкость: 'нечастая',
        когда: 'дневная',
        вода: { мин: 18, опт: 27, макс: 33 },
        течение: 'слабое',
        держится: ['открытая_вода', 'поверхность', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'пеллетс', вес: 1 },
            { чем: 'тесто', вес: 0.8 },
            { чем: 'зелень', вес: 0.2 },
        ],
    },
    {
        id: 'bighead_carp',
        семейство: 'карповые',
        latin: 'Hypophthalmichthys nobilis',
        повадка: 'карповый_силач',
        minKg: 1.5,
        maxKg: 30,
        typicalKg: 5,
        typicalLengthM: 0.7,
        depthM: 2.5,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'хрящевая',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 18, опт: 26, макс: 33 },
        течение: 'слабое',
        держится: ['открытая_вода', 'бровка', 'яма'],
        стая: 'большая_стая',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'пеллетс', вес: 1 },
            { чем: 'тесто', вес: 0.8 },
            { чем: 'рачок', вес: 0.4 },
            { чем: 'червь', вес: 0.2 },
        ],
    },
    {
        id: 'vimba',
        семейство: 'карповые',
        latin: 'Vimba vimba',
        повадка: 'стайная_бель',
        minKg: 0.1,
        maxKg: 1.5,
        typicalKg: 0.35,
        typicalLengthM: 0.28,
        depthM: 3,
        depthBandM: 2,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 8, опт: 18, макс: 26 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'камни', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'мотыль', вес: 0.6 },
            { чем: 'ручейник', вес: 0.4 },
            { чем: 'рачок', вес: 0.4 },
            { чем: 'ракушка', вес: 0.2 },
        ],
    },
    {
        id: 'sabrefish',
        семейство: 'карповые',
        latin: 'Pelecus cultratus',
        повадка: 'угонщик',
        minKg: 0.1,
        maxKg: 2,
        typicalKg: 0.4,
        typicalLengthM: 0.35,
        depthM: 0.8,
        depthBandM: 1.2,
        сложение: 'ленточное',
        пасть: 'тонкогубая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 10, опт: 20, макс: 28 },
        течение: 'слабое',
        держится: ['открытая_вода', 'поверхность', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'wobbler', вес: 0.4 },
        ],
    },
    {
        id: 'shemaya',
        семейство: 'карповые',
        latin: 'Alburnus chalcoides',
        повадка: 'стайная_бель',
        minKg: 0.05,
        maxKg: 0.8,
        typicalKg: 0.2,
        typicalLengthM: 0.25,
        depthM: 1.5,
        depthBandM: 1.5,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 8, опт: 18, макс: 26 },
        течение: 'слабое',
        держится: ['открытая_вода', 'поверхность', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'опарыш', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'кузнечик', вес: 0.4 },
            { чем: 'spinner', вес: 0.4 },
            { чем: 'мотыль', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'bleak',
        семейство: 'карповые',
        latin: 'Alburnus alburnus',
        повадка: 'мелочь',
        minKg: 0.01,
        maxKg: 0.15,
        typicalKg: 0.03,
        typicalLengthM: 0.12,
        depthM: 0.5,
        depthBandM: 0.8,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 8, опт: 20, макс: 28 },
        течение: 'слабое',
        держится: ['поверхность', 'открытая_вода', 'трава'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'опарыш', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'тесто', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'хлеб', вес: 0.4 },
            { чем: 'червь', вес: 0.4 },
        ],
    },
    {
        id: 'moderlieschen',
        семейство: 'карповые',
        latin: 'Leucaspius delineatus',
        повадка: 'мелочь',
        minKg: 0.005,
        maxKg: 0.05,
        typicalKg: 0.01,
        typicalLengthM: 0.07,
        depthM: 0.5,
        depthBandM: 0.6,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 12, опт: 22, макс: 30 },
        течение: 'стоячая',
        держится: ['поверхность', 'трава', 'открытая_вода'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'тесто', вес: 0.4 },
            { чем: 'хлеб', вес: 0.4 },
        ],
    },
    {
        id: 'gudgeon',
        семейство: 'карповые',
        latin: 'Gobio gobio',
        повадка: 'мелочь',
        minKg: 0.01,
        maxKg: 0.2,
        typicalKg: 0.03,
        typicalLengthM: 0.12,
        depthM: 1.5,
        depthBandM: 1,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 8, опт: 18, макс: 26 },
        течение: 'слабое',
        держится: ['твёрдое_дно', 'перекат', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'ручейник', вес: 0.4 },
        ],
    },
    {
        id: 'schneider',
        семейство: 'карповые',
        latin: 'Alburnoides bipunctatus',
        повадка: 'мелочь',
        minKg: 0.005,
        maxKg: 0.08,
        typicalKg: 0.02,
        typicalLengthM: 0.1,
        depthM: 0.8,
        depthBandM: 0.8,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'нечастая',
        когда: 'дневная',
        вода: { мин: 8, опт: 18, макс: 26 },
        течение: 'сильное',
        держится: ['перекат', 'камни', 'поверхность'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'опарыш', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'тесто', вес: 0.4 },
            { чем: 'червь', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'amur_bream',
        семейство: 'карповые',
        latin: 'Parabramis pekinensis',
        повадка: 'крупная_бель',
        minKg: 0.2,
        maxKg: 4,
        typicalKg: 0.9,
        typicalLengthM: 0.38,
        depthM: 3,
        depthBandM: 2,
        сложение: 'ленточное',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 14, опт: 24, макс: 31 },
        течение: 'слабое',
        держится: ['трава', 'бровка', 'открытая_вода'],
        стая: 'малая_стая',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'кукуруза', вес: 1 },
            { чем: 'зелень', вес: 0.8 },
            { чем: 'тесто', вес: 0.8 },
            { чем: 'пеллетс', вес: 0.6 },
            { чем: 'червь', вес: 0.4 },
            { чем: 'опарыш', вес: 0.4 },
        ],
    },
    {
        id: 'volga_nase',
        семейство: 'карповые',
        latin: 'Chondrostoma variabile',
        повадка: 'стайная_бель',
        minKg: 0.1,
        maxKg: 1.5,
        typicalKg: 0.35,
        typicalLengthM: 0.27,
        depthM: 2.5,
        depthBandM: 1.8,
        сложение: 'прогонистое',
        пасть: 'хрящевая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 6, опт: 17, макс: 25 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'перекат', 'камни'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'зелень', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'тесто', вес: 0.4 },
        ],
    },
    {
        id: 'bitterling',
        семейство: 'карповые',
        latin: 'Rhodeus amarus',
        повадка: 'мелочь',
        minKg: 0.003,
        maxKg: 0.03,
        typicalKg: 0.008,
        typicalLengthM: 0.06,
        depthM: 0.6,
        depthBandM: 0.6,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 12, опт: 22, макс: 30 },
        течение: 'стоячая',
        держится: ['трава', 'ил', 'твёрдое_дно'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'тесто', вес: 0.4 },
            { чем: 'хлеб', вес: 0.2 },
        ],
    },
    // ── Амурские вселенцы ──
    {
        id: 'amur_chebak',
        семейство: 'карповые',
        latin: 'Leuciscus waleckii',
        повадка: 'стайная_бель',
        minKg: 0.05,
        maxKg: 1,
        typicalKg: 0.2,
        typicalLengthM: 0.2,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 6, опт: 18, макс: 26 },
        течение: 'слабое',
        держится: ['коряги', 'трава', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'опарыш', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'тесто', вес: 0.6 },
            { чем: 'ручейник', вес: 0.4 },
            { чем: 'мушка', вес: 0.2 },
        ],
    },
    {
        id: 'skygazer',
        семейство: 'карповые',
        latin: 'Chanodichthys erythropterus',
        повадка: 'угонщик',
        minKg: 0.3,
        maxKg: 8,
        typicalKg: 1.2,
        typicalLengthM: 0.45,
        depthM: 1.5,
        depthBandM: 1.5,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'нечастая',
        когда: 'дневная',
        вода: { мин: 14, опт: 24, макс: 31 },
        течение: 'слабое',
        держится: ['открытая_вода', 'поверхность', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'jig', вес: 0.4 },
            { чем: 'мушка', вес: 0.2 },
        ],
    },
    {
        id: 'yellowcheek',
        семейство: 'карповые',
        latin: 'Elopichthys bambusa',
        повадка: 'угонщик',
        minKg: 1,
        maxKg: 30,
        typicalKg: 4,
        typicalLengthM: 0.7,
        depthM: 2,
        depthBandM: 2,
        сложение: 'прогонистое',
        пасть: 'костистая',
        редкость: 'очень_редкая',
        когда: 'дневная',
        вода: { мин: 15, опт: 24, макс: 31 },
        течение: 'сильное',
        держится: ['открытая_вода', 'бровка', 'перекат'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'jig', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    // ── Наши воды ──
    {
        id: 'asp',
        семейство: 'карповые',
        latin: 'Leuciscus aspius',
        повадка: 'угонщик',
        minKg: 0.4,
        maxKg: 5.5,
        typicalKg: 0.9,
        typicalLengthM: 0.45,
        depthM: 0.5,
        depthBandM: 1,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 8, опт: 20, макс: 28 },
        течение: 'сильное',
        держится: ['поверхность', 'перекат', 'открытая_вода'],
        стая: 'одиночка',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'кузнечик', вес: 0.4 },
            { чем: 'живец', вес: 0.4 },
            { чем: 'jig', вес: 0.2 },
        ],
        вИгре: 'asp',
    },
    // ── Иберия и Италия ──
    // Реки Дору, Тежу, Эбро и По. Здесь своя рыба: усачей четыре вида, и все не наши.
    {
        id: 'iberian_barbel',
        семейство: 'карповые',
        latin: 'Luciobarbus bocagei',
        повадка: 'карповый_силач',
        minKg: 0.2,
        maxKg: 4.5,
        typicalKg: 0.9,
        typicalLengthM: 0.45,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'массовая',
        когда: 'сумеречная',
        вода: { мин: 10, опт: 20, макс: 28 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'камни', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'кукуруза', вес: 0.8 },
            { чем: 'хлеб', вес: 0.6 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'тесто', вес: 0.4 },
            { чем: 'пеллетс', вес: 0.4 },
        ],
    },
    {
        id: 'comizo_barbel',
        семейство: 'карповые',
        latin: 'Luciobarbus comizo',
        повадка: 'донный_хищник',
        minKg: 0.5,
        maxKg: 10,
        typicalKg: 2.5,
        typicalLengthM: 0.65,
        depthM: 3,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 12, опт: 22, макс: 30 },
        течение: 'слабое',
        держится: ['яма', 'бровка', 'коряги'],
        стая: 'одиночка',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'wobbler', вес: 0.4 },
            { чем: 'кукуруза', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'gitano_barbel',
        семейство: 'карповые',
        latin: 'Luciobarbus sclateri',
        повадка: 'карповый_силач',
        minKg: 0.2,
        maxKg: 4,
        typicalKg: 0.9,
        typicalLengthM: 0.45,
        depthM: 2.5,
        depthBandM: 1.5,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'массовая',
        когда: 'сумеречная',
        вода: { мин: 12, опт: 22, макс: 30 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'бровка', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'кукуруза', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'хлеб', вес: 0.6 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'тесто', вес: 0.4 },
            { чем: 'пеллетс', вес: 0.4 },
        ],
    },
    {
        id: 'ebro_barbel',
        семейство: 'карповые',
        latin: 'Luciobarbus graellsii',
        повадка: 'карповый_силач',
        minKg: 0.3,
        maxKg: 6,
        typicalKg: 1.4,
        typicalLengthM: 0.55,
        depthM: 3,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 10, опт: 21, макс: 29 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'бровка', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'пеллетс', вес: 1 },
            { чем: 'бойл', вес: 0.8 },
            { чем: 'кукуруза', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'хлеб', вес: 0.4 },
            { чем: 'тесто', вес: 0.4 },
        ],
    },
    {
        id: 'iberian_nase',
        семейство: 'карповые',
        latin: 'Pseudochondrostoma polylepis',
        повадка: 'стайная_бель',
        minKg: 0.05,
        maxKg: 0.8,
        typicalKg: 0.25,
        typicalLengthM: 0.3,
        depthM: 1.5,
        depthBandM: 1,
        сложение: 'прогонистое',
        пасть: 'хрящевая',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 8, опт: 18, макс: 26 },
        течение: 'сильное',
        держится: ['камни', 'перекат', 'твёрдое_дно'],
        стая: 'большая_стая',
        нерест: { с: 3, по: 5 },
        чем: [
            { чем: 'тесто', вес: 1 },
            { чем: 'хлеб', вес: 0.8 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'зелень', вес: 0.6 },
            { чем: 'червь', вес: 0.4 },
            { чем: 'мотыль', вес: 0.4 },
        ],
    },
    {
        id: 'iberian_chub',
        семейство: 'карповые',
        latin: 'Squalius pyrenaicus',
        повадка: 'угонщик',
        minKg: 0.05,
        maxKg: 0.9,
        typicalKg: 0.25,
        typicalLengthM: 0.27,
        depthM: 1.5,
        depthBandM: 1,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'нечастая',
        когда: 'дневная',
        вода: { мин: 10, опт: 20, макс: 28 },
        течение: 'слабое',
        держится: ['поверхность', 'коряги', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'кузнечик', вес: 0.8 },
            { чем: 'хлеб', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'wobbler', вес: 0.4 },
            { чем: 'опарыш', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'italian_barbel',
        семейство: 'карповые',
        latin: 'Barbus plebejus',
        повадка: 'карповый_силач',
        minKg: 0.25,
        maxKg: 5,
        typicalKg: 1.2,
        typicalLengthM: 0.5,
        depthM: 2.5,
        depthBandM: 1.5,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 9, опт: 19, макс: 27 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'камни', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'кукуруза', вес: 0.8 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'пеллетс', вес: 0.6 },
            { чем: 'хлеб', вес: 0.4 },
            { чем: 'тесто', вес: 0.4 },
        ],
    },
    {
        id: 'italian_chub',
        семейство: 'карповые',
        latin: 'Squalius squalus',
        повадка: 'угонщик',
        minKg: 0.1,
        maxKg: 3,
        typicalKg: 0.7,
        typicalLengthM: 0.38,
        depthM: 1.5,
        depthBandM: 1.2,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 8, опт: 19, макс: 28 },
        течение: 'сильное',
        держится: ['поверхность', 'коряги', 'перекат'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'хлеб', вес: 0.8 },
            { чем: 'кузнечик', вес: 0.6 },
            { чем: 'фрукт', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
        ],
    },
    {
        id: 'italian_roach',
        семейство: 'карповые',
        latin: 'Rutilus aula',
        повадка: 'мелочь',
        minKg: 0.01,
        maxKg: 0.2,
        typicalKg: 0.05,
        typicalLengthM: 0.16,
        depthM: 1.5,
        depthBandM: 1,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 6, опт: 18, макс: 26 },
        течение: 'стоячая',
        держится: ['трава', 'открытая_вода', 'коряги'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'опарыш', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'тесто', вес: 0.6 },
            { чем: 'хлеб', вес: 0.6 },
            { чем: 'червь', вес: 0.4 },
        ],
    },
    // ── Балканы, Дунай и Междуречье ──
    {
        id: 'tigris_barbel',
        семейство: 'карповые',
        latin: 'Luciobarbus esocinus',
        повадка: 'донный_хищник',
        minKg: 2,
        maxKg: 45,
        typicalKg: 8,
        typicalLengthM: 1.1,
        depthM: 4,
        depthBandM: 3,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'очень_редкая',
        когда: 'ночная',
        вода: { мин: 14, опт: 24, макс: 32 },
        течение: 'слабое',
        держится: ['яма', 'бровка', 'коряги'],
        стая: 'одиночка',
        нерест: { с: 3, по: 5 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'мясо', вес: 0.6 },
            { чем: 'wobbler', вес: 0.4 },
            { чем: 'тесто', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'shabut',
        семейство: 'карповые',
        latin: 'Arabibarbus grypus',
        повадка: 'карповый_силач',
        minKg: 0.8,
        maxKg: 15,
        typicalKg: 3,
        typicalLengthM: 0.7,
        depthM: 3,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 14, опт: 25, макс: 33 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'бровка', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 3, по: 5 },
        чем: [
            { чем: 'тесто', вес: 1 },
            { чем: 'хлеб', вес: 0.8 },
            { чем: 'кукуруза', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'фрукт', вес: 0.4 },
            { чем: 'пеллетс', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    // ── Западная и Северная Европа ──
    {
        id: 'danube_roach',
        семейство: 'карповые',
        latin: 'Rutilus virgo',
        повадка: 'стайная_бель',
        minKg: 0.15,
        maxKg: 2,
        typicalKg: 0.6,
        typicalLengthM: 0.35,
        depthM: 3,
        depthBandM: 2,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 6, опт: 17, макс: 25 },
        течение: 'сильное',
        держится: ['бровка', 'твёрдое_дно', 'открытая_вода'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'опарыш', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'мотыль', вес: 0.6 },
            { чем: 'кукуруза', вес: 0.6 },
            { чем: 'тесто', вес: 0.4 },
            { чем: 'хлеб', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'pearlfish',
        семейство: 'карповые',
        latin: 'Rutilus meidingeri',
        повадка: 'крупная_бель',
        minKg: 0.3,
        maxKg: 4,
        typicalKg: 1,
        typicalLengthM: 0.45,
        depthM: 8,
        depthBandM: 5,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'очень_редкая',
        когда: 'сумеречная',
        вода: { мин: 4, опт: 14, макс: 22 },
        течение: 'стоячая',
        держится: ['бровка', 'яма', 'твёрдое_дно'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'опарыш', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'ракушка', вес: 0.6 },
            { чем: 'мотыль', вес: 0.6 },
            { чем: 'рачок', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'minnow',
        семейство: 'карповые',
        latin: 'Phoxinus phoxinus',
        повадка: 'мелочь',
        minKg: 0.002,
        maxKg: 0.03,
        typicalKg: 0.01,
        typicalLengthM: 0.08,
        depthM: 0.8,
        depthBandM: 0.6,
        сложение: 'округлое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 4, опт: 14, макс: 22 },
        течение: 'сильное',
        держится: ['перекат', 'камни', 'твёрдое_дно'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'опарыш', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'мушка', вес: 0.4 },
        ],
    },
    {
        id: 'mediterranean_barbel',
        семейство: 'карповые',
        latin: 'Barbus meridionalis',
        повадка: 'стайная_бель',
        minKg: 0.05,
        maxKg: 0.6,
        typicalKg: 0.2,
        typicalLengthM: 0.25,
        depthM: 1.5,
        depthBandM: 1,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 8, опт: 17, макс: 25 },
        течение: 'сильное',
        держится: ['камни', 'перекат', 'твёрдое_дно'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'ручейник', вес: 0.6 },
            { чем: 'мотыль', вес: 0.4 },
            { чем: 'тесто', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'topmouth_gudgeon',
        семейство: 'карповые',
        latin: 'Pseudorasbora parva',
        повадка: 'мелочь',
        minKg: 0.002,
        maxKg: 0.04,
        typicalKg: 0.01,
        typicalLengthM: 0.08,
        depthM: 1,
        depthBandM: 0.8,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 8, опт: 22, макс: 32 },
        течение: 'стоячая',
        держится: ['трава', 'ил', 'открытая_вода'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'тесто', вес: 0.4 },
        ],
    },
    // ── Восточная Европа, Кавказ, Средняя Азия и Сибирь ──
    // Балхаш, Иссык-Куль, Амударья, Байкал и Амур: маринки, османы и хариусы.
    {
        id: 'amur_redfin',
        семейство: 'карповые',
        latin: 'Pseudaspius leptocephalus',
        повадка: 'угонщик',
        minKg: 0.2,
        maxKg: 3,
        typicalKg: 0.8,
        typicalLengthM: 0.42,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 6, опт: 17, макс: 25 },
        течение: 'сильное',
        держится: ['перекат', 'открытая_вода', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
        ],
    },
    {
        id: 'mongolian_redfin',
        семейство: 'карповые',
        latin: 'Chanodichthys mongolicus',
        повадка: 'угонщик',
        minKg: 0.2,
        maxKg: 4,
        typicalKg: 0.9,
        typicalLengthM: 0.45,
        depthM: 3,
        depthBandM: 2,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'нечастая',
        когда: 'дневная',
        вода: { мин: 8, опт: 20, макс: 28 },
        течение: 'слабое',
        держится: ['открытая_вода', 'бровка', 'коряги'],
        стая: 'малая_стая',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'spoon', вес: 0.6 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'мушка', вес: 0.2 },
        ],
    },
    {
        id: 'balkhash_marinka',
        семейство: 'карповые',
        latin: 'Schizothorax argentatus',
        повадка: 'крупная_бель',
        minKg: 0.15,
        maxKg: 2.5,
        typicalKg: 0.6,
        typicalLengthM: 0.38,
        depthM: 2.5,
        depthBandM: 1.5,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 8, опт: 18, макс: 26 },
        течение: 'слабое',
        держится: ['камни', 'твёрдое_дно', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'тесто', вес: 0.8 },
            { чем: 'кузнечик', вес: 0.6 },
            { чем: 'зелень', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'живец', вес: 0.4 },
        ],
    },
    {
        id: 'common_marinka',
        семейство: 'карповые',
        latin: 'Schizothorax intermedius',
        повадка: 'стайная_бель',
        minKg: 0.1,
        maxKg: 2,
        typicalKg: 0.5,
        typicalLengthM: 0.35,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'массовая',
        когда: 'сумеречная',
        вода: { мин: 4, опт: 14, макс: 22 },
        течение: 'сильное',
        держится: ['камни', 'перекат', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'кузнечик', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'тесто', вес: 0.6 },
            { чем: 'зелень', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'опарыш', вес: 0.4 },
        ],
    },
    {
        id: 'naked_osman',
        семейство: 'карповые',
        latin: 'Gymnodiptychus dybowskii',
        повадка: 'крупная_бель',
        minKg: 0.2,
        maxKg: 3,
        typicalKg: 0.8,
        typicalLengthM: 0.42,
        depthM: 3,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 2, опт: 12, макс: 20 },
        течение: 'сильное',
        держится: ['камни', 'яма', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'кузнечик', вес: 0.8 },
            { чем: 'ручейник', вес: 0.6 },
            { чем: 'тесто', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'опарыш', вес: 0.4 },
        ],
    },
    {
        id: 'altai_osman',
        семейство: 'карповые',
        latin: 'Oreoleuciscus potanini',
        повадка: 'угонщик',
        minKg: 0.15,
        maxKg: 4,
        typicalKg: 0.6,
        typicalLengthM: 0.4,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 4, опт: 15, макс: 23 },
        течение: 'слабое',
        держится: ['открытая_вода', 'камни', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'spoon', вес: 0.6 },
            { чем: 'кузнечик', вес: 0.6 },
            { чем: 'живец', вес: 0.4 },
            { чем: 'мушка', вес: 0.4 },
        ],
    },
    {
        id: 'khramulya',
        семейство: 'карповые',
        latin: 'Capoeta capoeta',
        повадка: 'стайная_бель',
        minKg: 0.1,
        maxKg: 1.5,
        typicalKg: 0.4,
        typicalLengthM: 0.3,
        depthM: 1.5,
        depthBandM: 1,
        сложение: 'округлое',
        пасть: 'хрящевая',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 8, опт: 19, макс: 28 },
        течение: 'сильное',
        держится: ['камни', 'перекат', 'твёрдое_дно'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'зелень', вес: 1 },
            { чем: 'тесто', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'хлеб', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
        ],
    },
    {
        id: 'bulatmai_barbel',
        семейство: 'карповые',
        latin: 'Luciobarbus capito',
        повадка: 'карповый_силач',
        minKg: 0.5,
        maxKg: 10,
        typicalKg: 2,
        typicalLengthM: 0.6,
        depthM: 3,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 10, опт: 20, макс: 28 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'бровка', 'яма'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'ракушка', вес: 0.6 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'кукуруза', вес: 0.4 },
            { чем: 'тесто', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'pike_asp',
        семейство: 'карповые',
        latin: 'Aspiolucius esocinus',
        повадка: 'угонщик',
        minKg: 0.5,
        maxKg: 7,
        typicalKg: 2,
        typicalLengthM: 0.6,
        depthM: 2.5,
        depthBandM: 2,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'очень_редкая',
        когда: 'дневная',
        вода: { мин: 10, опт: 20, макс: 28 },
        течение: 'сильное',
        держится: ['открытая_вода', 'бровка', 'перекат'],
        стая: 'одиночка',
        нерест: { с: 3, по: 4 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'живец', вес: 0.6 },
        ],
        краснокнижная: true,
    },
    // ── Восточная Азия ──
    // Япония, Корея, Китай: херабуна, аю, ивана и амурские сомы.
    {
        id: 'herabuna',
        семейство: 'карповые',
        latin: 'Carassius cuvieri',
        повадка: 'крупная_бель',
        minKg: 0.15,
        maxKg: 2.5,
        typicalKg: 0.5,
        typicalLengthM: 0.35,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 10, опт: 22, макс: 30 },
        течение: 'стоячая',
        держится: ['открытая_вода', 'трава', 'ил'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'тесто', вес: 1 },
            { чем: 'пеллетс', вес: 0.6 },
            { чем: 'хлеб', вес: 0.4 },
        ],
    },
    {
        id: 'ugui',
        семейство: 'карповые',
        latin: 'Tribolodon hakonensis',
        повадка: 'стайная_бель',
        minKg: 0.05,
        maxKg: 0.8,
        typicalKg: 0.25,
        typicalLengthM: 0.3,
        depthM: 1.5,
        depthBandM: 1,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 5, опт: 15, макс: 24 },
        течение: 'сильное',
        держится: ['перекат', 'камни', 'твёрдое_дно'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'икра', вес: 0.8 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'spinner', вес: 0.4 },
            { чем: 'кузнечик', вес: 0.4 },
            { чем: 'тесто', вес: 0.2 },
        ],
    },
    {
        id: 'hasu',
        семейство: 'карповые',
        latin: 'Opsariichthys uncirostris',
        повадка: 'угонщик',
        minKg: 0.05,
        maxKg: 0.6,
        typicalKg: 0.2,
        typicalLengthM: 0.25,
        depthM: 1.5,
        depthBandM: 1.2,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 12, опт: 22, макс: 30 },
        течение: 'слабое',
        держится: ['поверхность', 'открытая_вода', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'spoon', вес: 0.4 },
            { чем: 'червь', вес: 0.4 },
        ],
    },
    {
        id: 'wuchang_bream',
        семейство: 'карповые',
        latin: 'Megalobrama amblycephala',
        повадка: 'крупная_бель',
        minKg: 0.15,
        maxKg: 3,
        typicalKg: 0.6,
        typicalLengthM: 0.35,
        depthM: 3,
        depthBandM: 2,
        сложение: 'ленточное',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 12, опт: 25, макс: 32 },
        течение: 'стоячая',
        держится: ['трава', 'открытая_вода', 'ил'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'пеллетс', вес: 1 },
            { чем: 'зелень', вес: 0.8 },
            { чем: 'тесто', вес: 0.8 },
            { чем: 'кукуруза', вес: 0.6 },
            { чем: 'горох', вес: 0.4 },
            { чем: 'хлеб', вес: 0.4 },
        ],
    },
    {
        id: 'chinese_culter',
        семейство: 'карповые',
        latin: 'Culter alburnus',
        повадка: 'угонщик',
        minKg: 0.2,
        maxKg: 6,
        typicalKg: 0.8,
        typicalLengthM: 0.5,
        depthM: 3,
        depthBandM: 2,
        сложение: 'ленточное',
        пасть: 'тонкогубая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 10, опт: 24, макс: 32 },
        течение: 'слабое',
        держится: ['открытая_вода', 'поверхность', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'spoon', вес: 0.6 },
            { чем: 'рачок', вес: 0.4 },
        ],
    },
    {
        id: 'barbel_steed',
        семейство: 'карповые',
        latin: 'Hemibarbus labeo',
        повадка: 'крупная_бель',
        minKg: 0.15,
        maxKg: 2.5,
        typicalKg: 0.6,
        typicalLengthM: 0.35,
        depthM: 2.5,
        depthBandM: 1.5,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 8, опт: 20, макс: 28 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'камни', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'рачок', вес: 0.8 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'ракушка', вес: 0.6 },
            { чем: 'мотыль', вес: 0.4 },
            { чем: 'тесто', вес: 0.4 },
        ],
    },
    // ── Тропики и Южное полушарие ──
    // Ганг, Меконг, Амазонка, Замбези, Мюррей. Отсюда все девять тропических гигантов.
    {
        id: 'golden_mahseer',
        семейство: 'карповые',
        latin: 'Tor putitora',
        повадка: 'тропический_гигант',
        minKg: 1,
        maxKg: 30,
        typicalKg: 4,
        typicalLengthM: 0.9,
        depthM: 3,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 14, опт: 24, макс: 32 },
        течение: 'сильное',
        держится: ['камни', 'яма', 'перекат'],
        стая: 'малая_стая',
        нерест: { с: 7, по: 9 },
        чем: [
            { чем: 'тесто', вес: 1 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'червь', вес: 0.4 },
            { чем: 'мушка', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'rohu',
        семейство: 'карповые',
        latin: 'Labeo rohita',
        повадка: 'карповый_силач',
        minKg: 0.4,
        maxKg: 8,
        typicalKg: 1.5,
        typicalLengthM: 0.55,
        depthM: 3,
        depthBandM: 2,
        сложение: 'высокотелое',
        пасть: 'кожистая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 15, опт: 28, макс: 35 },
        течение: 'слабое',
        держится: ['открытая_вода', 'ил', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 6, по: 8 },
        чем: [
            { чем: 'тесто', вес: 1 },
            { чем: 'пеллетс', вес: 0.8 },
            { чем: 'хлеб', вес: 0.6 },
            { чем: 'кукуруза', вес: 0.6 },
            { чем: 'зелень', вес: 0.4 },
        ],
    },
    {
        id: 'siamese_carp',
        семейство: 'карповые',
        latin: 'Catlocarpio siamensis',
        повадка: 'тропический_гигант',
        minKg: 5,
        maxKg: 70,
        typicalKg: 20,
        typicalLengthM: 1.2,
        depthM: 4,
        depthBandM: 3,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'единичная',
        когда: 'сумеречная',
        вода: { мин: 18, опт: 28, макс: 35 },
        течение: 'слабое',
        держится: ['яма', 'коряги', 'открытая_вода'],
        стая: 'одиночка',
        нерест: { с: 5, по: 8 },
        чем: [
            { чем: 'тесто', вес: 1 },
            { чем: 'хлеб', вес: 0.8 },
            { чем: 'пеллетс', вес: 0.8 },
            { чем: 'бойл', вес: 0.6 },
            { чем: 'кукуруза', вес: 0.6 },
        ],
        краснокнижная: true,
    },
];
//# sourceMappingURL=cyprinids.js.map